export const cs = {
  returnLineItems: {
    refund: "Vrácení peněz",
    exchange: "Výměna",
    discount: "Sleva",
  },
  returnStoreAddress: {
    mapButton: "Zobrazit na mapě",
  },
  downloadLabel: {
    label: "Stáhnout můj štítek",
    bonDeRetour: "Stáhnout formulář pro vrácení",
  },
  returnRequestDate: {
    label: "Vaše žádost o vrácení byla podána {{date}} v {{time}}",
  },
  actions: {
    continue: "Pokračovat",
  },
  "order-identification": {
    title: "Sledujte svou objednávku",
    description: "Zadejte údaje o objednávce pro sledování zásilky",
    fields: {
      "zip-code": {
        title: "PSČ",
        description: "Zadejte vaše doručovací PSČ",
        required: "PSČ je povinné",
      },
      email: {
        title: "E-mailová adresa",
        description: "Zadejte e-mailovou adresu použitou při objednávce",
        required: "E-mailová adresa je povinná",
      },
      "tracking-number": {
        title: "Číslo objednávky",
        description: "Zadejte číslo vaší objednávky",
        required: "Číslo objednávky je povinné",
      },
    },
    errors: {
      "unknown-order": {
        title: "Neznámé číslo objednávky",
        description: "Číslo objednávky nebylo nalezeno, zkontrolujte ho prosím",
      },
      "search-error": {
        title: "Chyba vyhledávání",
        description:
          "Nepodařilo se nám najít objednávku. Zkuste to prosím později.",
      },
    },
  },
  delivery: "Doručení",
  "parcel-history": "Historie balíku",
  "order-details": {
    title: "Detaily objednávky",
    "tracking-number": "Sledovací číslo",
    "order-number": "Číslo objednávky",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Odhadované datum doručení",
      deliveredOn: "Doručeno dne",
      from: "od",
      to: "do",
    },
  },
  deliveryAddress: {
    title: "Dodací adresa:",
    titlePickup: "Adresa výdejního místa:",
    orderDetails: {
      title: "Detaily objednávky:",
      trackingNumber: "Sledovací číslo:",
      orderNumber: "Číslo objednávky:",
      orderDate: "Datum objednávky:",
    },
  },
  pickupPoint: {
    title: "Výdejní místo",
    openingHours: "Otevírací doba:",
    closed: "Zavřeno",
    directions: "Trasa",
    days: {
      monday: "Pondělí:",
      tuesday: "Úterý:",
      wednesday: "Středa:",
      thursday: "Čtvrtek:",
      friday: "Pátek:",
      saturday: "Sobota:",
      sunday: "Neděle:",
    },
  },
  wallet: {
    warningNotEnabled: "Musíte povolit Wallet v nastavení svého obchodu",
  },
  crossSell: {
    youMightAlsoLike: "Mohlo by se vám také líbit",
  },
  "rate-order": {
    "order-recap": {
      title: "Vaše objednávka",
      "tracking-label": "Sledovací číslo:",
      "order-label": "Číslo objednávky:",
    },
    form: {
      title: "Ohodnoťte své doručení",
      "rating-label": "Ohodnoťte zážitek z doručení",
      "comment-label": "Komentář (nepovinné)",
      "comment-placeholder": "Podělte se s námi o svůj zážitek…",
      "submit-cta": "Odeslat hodnocení",
      "update-cta": "Aktualizovat hodnocení",
      "rating-required": "Vyberte prosím hodnocení.",
    },
    "thank-you": {
      title: "Děkujeme za vaši zpětnou vazbu!",
      description:
        "Vaše hodnocení bylo uloženo. Pomůže nám vylepšit zážitek z doručení.",
    },
    errors: {
      "invalid-token": {
        title: "Neplatný nebo vypršelý odkaz",
        description:
          "Tento odkaz již není platný. Otevřete ho prosím znovu z vašeho posledního sledovacího e-mailu.",
      },
      submit: {
        title: "Něco se pokazilo",
        description:
          "Nepodařilo se nám uložit vaše hodnocení. Zkuste to prosím později.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Nyní si můžete vytisknout zpětný štítek a odevzdat balíček v nejbližším výdejním místě Colissimo.",
    chronoShop2Shop: "Nyní si můžete vytisknout zpětný štítek a odevzdat balíček v nejbližším výdejním místě Chronopost.",
    ups: "Nyní si můžete vytisknout zpětný štítek a odevzdat balíček v nejbližším výdejním místě UPS.",
    customerCarrier: "Nyní můžete poslat balíček k vrácení dopravci dle vašeho výběru.",
    merchantCarrier: "Zasíláme vám zpětný štítek e-mailem během 1 až 3 pracovních dnů.",
    returnToStore: "Nyní můžete odevzdat balíček v nejbližší prodejně.",
    malca: "Nyní si můžete vytisknout zpětný štítek a odevzdat balíček v nejbližším výdejním místě Malca.",
    tnt: "Nyní si můžete vytisknout zpětný štítek a odevzdat balíček v nejbližším výdejním místě TNT.",
    bonDeRetour: "Váš přepravní štítek je připraven. Nyní si jej můžete vytisknout a použít pro vrácení.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Váš přepravní štítek je připraven",
    bonDeRetour: "Váš formulář pro vrácení je připraven",
  },
} as const;
